import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState: any = {
  faqList: [],
  faqTypes: [],
  userGuides: [],
};
const faqsSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {
    setFaqList: (state, action: PayloadAction<any>) => {
      state.faqList = action.payload;
    },
    setFaqTypes: (state, action: PayloadAction<any>) => {
      state.faqTypes = action.payload;
    },
    setUserGuides: (state, action: PayloadAction<any>) => {
      state.userGuides = action.payload;
    },
  },
});
export const { setFaqList, setFaqTypes, setUserGuides } = faqsSlice.actions;
export default faqsSlice.reducer;
export const faqList = (state: RootState) => state.faqs.faqList;
export const faqTypes = (state: RootState) => state.faqs.faqTypes;
export const userGuides = (state: RootState) => state.faqs.userGuides;